// The Competitors URL query string is the single source of truth for filters, shared by the
// list and the map. UI params map 1:1 to API params except `demo` (include/hide/only) and `view`.

export const MULTI_KEYS = ['country', 'city', 'team_size', 'service', 'tag', 'interest', 'depth', 'completeness'] as const;
export type MultiKey = (typeof MULTI_KEYS)[number];

export type DemoMode = 'include' | 'hide' | 'only';

export function demoMode(sp: URLSearchParams): DemoMode {
  const v = sp.get('demo');
  return v === 'hide' || v === 'only' ? v : 'include';
}

export function truthy(v: string | null): boolean {
  return v === '1' || v === 'true' || v === 'yes';
}

/** API query for /api/studios, /api/studios/map and /api/studios/export.csv. */
export function apiQuery(sp: URLSearchParams): URLSearchParams {
  const out = new URLSearchParams();
  for (const k of MULTI_KEYS) sp.getAll(k).forEach((v) => out.append(k, v));
  const q = sp.get('q')?.trim();
  if (q) out.set('q', q);
  const loc = sp.get('location');
  if (loc === 'mapped' || loc === 'unmapped') out.set('location', loc);
  const demo = demoMode(sp);
  if (demo === 'hide') out.set('include_demo', 'false');
  if (demo === 'only') out.set('demo_only', 'true');
  if (truthy(sp.get('include_dismissed'))) out.set('include_dismissed', 'true');
  const batch = sp.get('batch_id');
  if (batch) out.set('batch_id', batch);
  const sort = sp.get('sort');
  if (sort) out.set('sort', sort);
  return out;
}

export function activeFilterCount(sp: URLSearchParams): number {
  let n = 0;
  for (const k of MULTI_KEYS) n += sp.getAll(k).length ? 1 : 0;
  if (sp.get('q')) n++;
  if (sp.get('location')) n++;
  if (demoMode(sp) !== 'include') n++;
  if (truthy(sp.get('include_dismissed'))) n++;
  if (sp.get('batch_id')) n++;
  return n;
}
